import * as React from 'react';
import styled from 'styled-components';

export const IconCoin = styled((props) => (
  <svg width={274} height={276} viewBox="0 0 274 276" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_765_5350)">
      <g filter="url(#filter0_f_765_5350)">
        <ellipse cx={135.557} cy={162.801} rx={105.123} ry={104.854} fill="#494C61" fillOpacity={0.41} />
      </g>
      <path
        d="M202.091 221.989L183.418 235.068L190.472 236.475L209.145 223.396L202.091 221.989Z"
        fill="#C96D00"
        stroke="#303030"
        strokeWidth={1.20463}
        strokeMiterlimit={10}
      />
      <path
        d="M92.6202 68.4316C86.3958 72.7362 80.1714 77.1235 73.947 81.4281C61.4982 90.12 52.0371 102.785 46.8086 118.017L65.4818 105.02C70.7103 89.7888 80.1714 77.1235 92.6202 68.4316Z"
        fill="url(#paint0_linear_765_5350)"
        stroke="#303030"
        strokeWidth={1.20463}
        strokeMiterlimit={10}
      />
      <path
        d="M65.4027 105.021L46.7295 118.017L51.543 124.97L70.2162 111.891L65.4027 105.021Z"
        fill="#C96D00"
        stroke="#303030"
        strokeWidth={1.20463}
        strokeMiterlimit={10}
      />
      <path
        d="M100.254 211.972L81.5811 224.968L82.8259 230.266L101.499 217.27L100.254 211.972Z"
        fill="#C96D00"
        stroke="#303030"
        strokeWidth={1.20463}
        strokeMiterlimit={10}
      />
      <path
        d="M101.5 217.27L82.8271 230.266C98.8446 243.511 118.182 251.955 138.515 253.196C154.117 254.107 168.309 250.547 180.26 243.677L198.933 230.68C186.982 237.551 172.79 241.11 157.188 240.2C136.855 239.041 117.518 230.515 101.5 217.27Z"
        fill="url(#paint1_linear_765_5350)"
        stroke="#303030"
        strokeWidth={1.20463}
        strokeMiterlimit={10}
      />
      <path
        d="M95.1947 211.641L76.5215 224.637L81.584 224.968L100.257 211.972L95.1947 211.641Z"
        fill="#F69D05"
        stroke="#303030"
        strokeWidth={1.20463}
        strokeMiterlimit={10}
      />
      <path
        d="M63.4914 111.56L44.8182 124.557C42.3284 134.242 41.4985 144.838 42.5774 155.93C45.1501 182.42 58.0139 206.84 76.5211 224.637L95.1943 211.641C76.6871 193.843 63.8233 169.423 61.2506 142.934C60.1717 131.758 61.0016 121.245 63.4914 111.477V111.56Z"
        fill="url(#paint2_linear_765_5350)"
        stroke="#303030"
        strokeWidth={1.20463}
        strokeMiterlimit={10}
      />
      <g
        style={{
          mixBlendMode: 'overlay',
        }}
        opacity={0.7}
      >
        <path
          d="M62.3299 112.222C59.8401 121.908 59.0102 132.503 60.0891 143.679C62.6619 170.168 75.5256 194.588 94.0328 212.386L99.0954 212.717L100.34 218.015C116.358 231.26 135.695 239.703 156.028 240.945C171.63 241.856 185.822 238.296 197.773 231.425L200.927 222.816L207.981 224.223C226.488 208.495 236.945 183.165 234.04 153.778C233.21 145.003 231.219 136.477 228.314 128.364C225.077 125.384 221.924 121.742 221.758 121.494L222.587 115.285C208.23 87.3056 182.419 65.7828 153.289 58.8293L145.488 61.6438L128.06 56.5942C97.6845 58.581 73.8658 77.8687 64.2387 105.765L69.0523 112.719L62.2469 112.305L62.3299 112.222Z"
          fill="url(#paint3_linear_765_5350)"
          style={{
            mixBlendMode: 'overlay',
          }}
        />
        <path
          d="M62.3299 112.222C59.8401 121.908 59.0102 132.503 60.0891 143.679C62.6619 170.168 75.5256 194.588 94.0328 212.386L99.0954 212.717L100.34 218.015C116.358 231.26 135.695 239.703 156.028 240.945C171.63 241.856 185.822 238.296 197.773 231.425L200.927 222.816L207.981 224.223C226.488 208.495 236.945 183.165 234.04 153.778C233.21 145.003 231.219 136.477 228.314 128.364C225.077 125.384 221.924 121.742 221.758 121.494L222.587 115.285C208.23 87.3056 182.419 65.7828 153.289 58.8293L145.488 61.6438L128.06 56.5942C97.6845 58.581 73.8658 77.8687 64.2387 105.765L69.0523 112.719L62.2469 112.305L62.3299 112.222Z"
          stroke="#303030"
          strokeWidth={1.20463}
          strokeMiterlimit={10}
        />
      </g>
      <path
        d="M63.492 111.56C61.0022 121.245 60.1723 131.841 61.2512 143.016C63.824 169.506 76.6877 193.926 95.195 211.724L100.257 212.055L101.502 217.353C117.52 230.597 136.857 239.041 157.19 240.283C172.792 241.193 186.984 237.634 198.935 230.763L202.089 222.154L209.143 223.561C227.65 207.833 238.107 182.502 235.202 153.115C234.373 144.341 232.381 135.814 229.476 127.702C226.239 124.722 223.086 121.08 222.92 120.831L223.75 114.623C209.392 86.6432 183.581 65.1205 154.451 58.167L146.65 60.9815L129.222 55.8491C98.8466 57.8358 75.0279 77.1235 65.4008 105.02L70.2144 111.974L63.409 111.56H63.492Z"
        fill="url(#paint4_linear_765_5350)"
        stroke="#303030"
        strokeWidth={1.20463}
        strokeMiterlimit={10}
      />
      <g
        style={{
          mixBlendMode: 'overlay',
        }}
        opacity={0.7}
      >
        <path
          d="M143.496 81.0142C108.556 79.0275 83.0774 107.421 86.646 144.506C90.2147 181.592 121.503 213.296 156.525 215.283C191.465 217.27 216.943 188.876 213.375 151.791C209.806 114.706 178.518 83.0009 143.496 81.0142Z"
          fill="url(#paint5_linear_765_5350)"
          style={{
            mixBlendMode: 'overlay',
          }}
        />
        <path
          d="M143.496 81.0142C108.556 79.0275 83.0774 107.421 86.646 144.506C90.2147 181.592 121.503 213.296 156.525 215.283C191.465 217.27 216.943 188.876 213.375 151.791C209.806 114.706 178.518 83.0009 143.496 81.0142Z"
          stroke="#303030"
          strokeWidth={1.20463}
          strokeMiterlimit={10}
        />
      </g>
      <path
        d="M141.752 80.8487C106.813 78.862 81.3342 107.255 84.9028 144.341C88.4715 181.426 119.759 213.131 154.782 215.118C189.722 217.104 215.2 188.711 211.632 151.625C208.063 114.54 176.775 82.8354 141.752 80.8487Z"
        fill="url(#paint6_linear_765_5350)"
        stroke="#303030"
        strokeWidth={1.20463}
        strokeMiterlimit={10}
      />
      <path
        d="M149.39 214.372C184.329 216.359 209.808 187.966 206.239 150.88C202.919 116.527 175.864 86.8087 144.078 81.0142C178.105 84.2426 208.148 115.368 211.634 151.625C215.202 188.711 189.807 217.104 154.784 215.118C152.211 214.952 149.639 214.621 147.066 214.207C147.813 214.207 148.56 214.372 149.39 214.372Z"
        fill="#A6730E"
        stroke="#303030"
        strokeWidth={1.20463}
        strokeMiterlimit={10}
      />
      <path
        style={{
          mixBlendMode: 'overlay',
        }}
        opacity={0.5}
        d="M68.8841 185.317C77.4322 202.452 86.3954 215.283 89.0511 214.041C91.6239 212.8 86.8103 197.817 78.2621 180.681C69.714 163.546 60.7508 150.715 58.0951 151.957C55.5223 153.198 60.3359 168.181 68.8841 185.317Z"
        fill="url(#paint7_radial_765_5350)"
      />
      <path
        style={{
          mixBlendMode: 'overlay',
        }}
        opacity={0.4}
        d="M146.65 60.8157L154.451 58.0012C162.999 60.0707 171.298 63.3819 179.1 67.6865L235.617 160.234C235.949 174.224 233.21 187.138 227.982 198.396L143.33 59.9052L146.65 60.8985V60.8157Z"
        fill="url(#paint8_linear_765_5350)"
      />
      <path
        style={{
          mixBlendMode: 'overlay',
        }}
        opacity={0.4}
        d="M100.507 63.7129L200.18 226.955L198.852 230.597C186.902 237.468 172.71 241.027 157.108 240.117C153.622 239.951 150.136 239.454 146.651 238.875L69.136 111.891H70.2149L65.4014 105.02C71.7088 86.7257 84.1576 72.1564 100.507 63.7129Z"
        fill="url(#paint9_linear_765_5350)"
      />
      <path
        d="M136.086 118.333H150.249L149.86 176.309L138.421 176.542V155.92L132.584 174.597H122.234L117.643 159.422L117.409 174.052L105.892 174.363L105.191 119.656L118.576 118.567L127.837 152.263L136.086 118.333Z"
        fill="#A04D00"
      />
      <path
        d="M193.389 158.096C192.383 167.741 187.35 176.548 176.363 176.548C161.769 176.548 157.156 158.347 157.156 146.605C157.156 134.779 161.853 116.663 176.363 116.663C187.099 116.663 193.808 124.379 193.808 135.115L180.557 136.54C180.64 134.444 180.473 132.598 179.886 131.089C179.298 129.663 178.124 128.908 176.363 128.908C171.247 128.908 170.827 143.418 170.827 146.689C170.827 150.379 171.582 164.47 176.363 164.47C177.789 164.47 178.795 163.799 179.382 162.457C179.886 161.115 180.221 159.438 180.221 157.425L193.389 158.096Z"
        fill="#A04D00"
      />
      <mask
        id="path-19-outside-1_765_5350"
        maskUnits="userSpaceOnUse"
        x={101.963}
        y={119.749}
        width={47}
        height={60}
        fill="black"
      >
        <rect fill="white" x={101.963} y={119.749} width={47} height={60} />
        <path d="M133.857 120.43H148.021L147.632 178.406L136.192 178.64V158.017L130.356 176.694H120.005L115.414 161.519L115.181 176.149L103.663 176.461L102.963 121.753L116.348 120.664L125.608 154.36L133.857 120.43Z" />
      </mask>
      <path
        d="M133.857 120.43H148.021L147.632 178.406L136.192 178.64V158.017L130.356 176.694H120.005L115.414 161.519L115.181 176.149L103.663 176.461L102.963 121.753L116.348 120.664L125.608 154.36L133.857 120.43Z"
        fill="#FCC12B"
      />
      <path
        d="M133.857 120.43V119.985H133.508L133.425 120.325L133.857 120.43ZM148.021 120.43L148.465 120.433L148.468 119.985H148.021V120.43ZM147.632 178.406L147.641 178.851L148.073 178.842L148.076 178.409L147.632 178.406ZM136.192 178.64H135.747V179.093L136.201 179.084L136.192 178.64ZM136.192 158.017H136.637L135.767 157.885L136.192 158.017ZM130.356 176.694V177.139H130.683L130.78 176.827L130.356 176.694ZM120.005 176.694L119.58 176.823L119.675 177.139H120.005V176.694ZM115.414 161.519L115.84 161.39L114.969 161.512L115.414 161.519ZM115.181 176.149L115.193 176.594L115.619 176.582L115.625 176.156L115.181 176.149ZM103.663 176.461L103.219 176.466L103.224 176.917L103.675 176.905L103.663 176.461ZM102.963 121.753L102.927 121.31L102.513 121.344L102.518 121.759L102.963 121.753ZM116.348 120.664L116.777 120.546L116.679 120.19L116.312 120.22L116.348 120.664ZM125.608 154.36L125.18 154.478L125.635 156.134L126.041 154.465L125.608 154.36ZM133.857 120.875H148.021V119.985H133.857V120.875ZM147.576 120.427L147.187 178.403L148.076 178.409L148.465 120.433L147.576 120.427ZM147.622 177.961L136.183 178.195L136.201 179.084L147.641 178.851L147.622 177.961ZM136.637 178.64V158.017H135.747V178.64H136.637ZM135.767 157.885L129.931 176.561L130.78 176.827L136.617 158.15L135.767 157.885ZM130.356 176.249H120.005V177.139H130.356V176.249ZM120.431 176.565L115.84 161.39L114.988 161.648L119.58 176.823L120.431 176.565ZM114.969 161.512L114.736 176.142L115.625 176.156L115.859 161.526L114.969 161.512ZM115.169 175.705L103.651 176.016L103.675 176.905L115.193 176.594L115.169 175.705ZM104.108 176.455L103.408 121.747L102.518 121.759L103.219 176.466L104.108 176.455ZM102.999 122.196L116.384 121.107L116.312 120.22L102.927 121.31L102.999 122.196ZM115.919 120.782L125.18 154.478L126.037 154.242L116.777 120.546L115.919 120.782ZM126.041 154.465L134.29 120.535L133.425 120.325L125.176 154.255L126.041 154.465Z"
        fill="black"
        mask="url(#path-19-outside-1_765_5350)"
      />
      <mask
        id="path-21-outside-2_765_5350"
        maskUnits="userSpaceOnUse"
        x={153.844}
        y={118.02}
        width={39}
        height={62}
        fill="black"
      >
        <rect fill="white" x={153.844} y={118.02} width={39} height={62} />
        <path d="M191.161 160.155C190.154 169.8 185.122 178.607 174.134 178.607C159.541 178.607 154.928 160.406 154.928 148.664C154.928 136.838 159.624 118.722 174.134 118.722C184.87 118.722 191.58 126.438 191.58 137.174L178.328 138.599C178.412 136.503 178.244 134.657 177.657 133.148C177.07 131.722 175.896 130.967 174.134 130.967C169.018 130.967 168.599 145.477 168.599 148.748C168.599 152.438 169.354 166.529 174.134 166.529C175.56 166.529 176.567 165.858 177.154 164.516C177.657 163.174 177.993 161.497 177.993 159.484L191.161 160.155Z" />
      </mask>
      <path
        d="M191.161 160.155C190.154 169.8 185.122 178.607 174.134 178.607C159.541 178.607 154.928 160.406 154.928 148.664C154.928 136.838 159.624 118.722 174.134 118.722C184.87 118.722 191.58 126.438 191.58 137.174L178.328 138.599C178.412 136.503 178.244 134.657 177.657 133.148C177.07 131.722 175.896 130.967 174.134 130.967C169.018 130.967 168.599 145.477 168.599 148.748C168.599 152.438 169.354 166.529 174.134 166.529C175.56 166.529 176.567 165.858 177.154 164.516C177.657 163.174 177.993 161.497 177.993 159.484L191.161 160.155Z"
        fill="#FCC12B"
      />
      <path
        d="M191.161 160.155L191.603 160.201L191.652 159.734L191.183 159.71L191.161 160.155ZM191.58 137.174L191.628 137.616L192.025 137.573V137.174H191.58ZM178.328 138.599L177.884 138.582L177.863 139.097L178.376 139.042L178.328 138.599ZM177.657 133.148L178.072 132.986L178.068 132.978L177.657 133.148ZM177.154 164.516L177.561 164.694L177.566 164.683L177.57 164.672L177.154 164.516ZM177.993 159.484L178.015 159.039L177.548 159.016V159.484H177.993ZM190.718 160.109C190.221 164.877 188.731 169.398 186.045 172.718C183.371 176.022 179.492 178.162 174.134 178.162V179.051C179.764 179.051 183.895 176.788 186.736 173.277C189.564 169.783 191.094 165.078 191.603 160.201L190.718 160.109ZM174.134 178.162C167.068 178.162 162.391 173.771 159.457 167.841C156.519 161.903 155.372 154.49 155.372 148.664H154.483C154.483 154.58 155.643 162.139 158.66 168.236C161.681 174.342 166.607 179.051 174.134 179.051V178.162ZM155.372 148.664C155.372 142.797 156.539 135.384 159.488 129.456C162.432 123.536 167.109 119.166 174.134 119.166V118.277C166.65 118.277 161.723 122.965 158.692 129.06C155.664 135.147 154.483 142.705 154.483 148.664H155.372ZM174.134 119.166C179.39 119.166 183.629 121.052 186.556 124.223C189.487 127.399 191.135 131.898 191.135 137.174H192.025C192.025 131.714 190.318 126.987 187.21 123.62C184.099 120.249 179.615 118.277 174.134 118.277V119.166ZM191.532 136.731L178.28 138.157L178.376 139.042L191.628 137.616L191.532 136.731ZM178.772 138.617C178.857 136.494 178.691 134.578 178.072 132.987L177.243 133.309C177.798 134.736 177.966 136.511 177.884 138.582L178.772 138.617ZM178.068 132.978C177.744 132.191 177.248 131.568 176.572 131.146C175.899 130.725 175.078 130.522 174.134 130.522V131.412C174.952 131.412 175.599 131.587 176.1 131.9C176.599 132.211 176.983 132.678 177.246 133.317L178.068 132.978ZM174.134 130.522C172.607 130.522 171.505 131.613 170.719 133.075C169.928 134.547 169.386 136.516 169.011 138.55C168.259 142.626 168.154 147.103 168.154 148.748H169.044C169.044 147.122 169.148 142.708 169.885 138.712C170.255 136.709 170.777 134.847 171.503 133.496C172.235 132.135 173.104 131.412 174.134 131.412V130.522ZM168.154 148.748C168.154 150.61 168.344 155.086 169.137 159.109C169.534 161.116 170.087 163.044 170.861 164.481C171.627 165.902 172.686 166.974 174.134 166.974V166.084C173.193 166.084 172.364 165.395 171.644 164.059C170.933 162.738 170.4 160.913 170.01 158.936C169.231 154.991 169.044 150.576 169.044 148.748H168.154ZM174.134 166.974C174.919 166.974 175.617 166.788 176.205 166.396C176.793 166.004 177.241 165.427 177.561 164.694L176.746 164.338C176.48 164.947 176.131 165.377 175.712 165.656C175.294 165.934 174.776 166.084 174.134 166.084V166.974ZM177.57 164.672C178.094 163.277 178.437 161.546 178.437 159.484H177.548C177.548 161.447 177.221 163.071 176.737 164.36L177.57 164.672ZM177.97 159.928L191.138 160.599L191.183 159.71L178.015 159.039L177.97 159.928Z"
        fill="black"
        mask="url(#path-21-outside-2_765_5350)"
      />
      <path
        style={{
          mixBlendMode: 'overlay',
        }}
        opacity={0.4}
        d="M100.507 63.7129L200.18 226.955L198.852 230.597C186.902 237.468 172.71 241.027 157.108 240.117C153.622 239.951 150.136 239.454 146.651 238.875L69.136 111.891H70.2149L65.4014 105.02C71.7088 86.7257 84.1576 72.1564 100.507 63.7129Z"
        fill="url(#paint10_linear_765_5350)"
      />
      <g filter="url(#filter1_f_765_5350)">
        <ellipse cx={170.139} cy={64.8444} rx={34.58} ry={34.4916} fill="#D9D9D9" fillOpacity={0.31} />
      </g>
      <path
        d="M170.095 83.1047C170.095 65.1619 155.9 63.2296 155.9 63.2296C155.9 63.2296 170.095 63.8737 170.095 42.5264C170.095 63.7817 184.289 63.2296 184.289 63.2296C184.289 63.2296 170.095 65.1619 170.095 83.1047Z"
        fill="white"
        fillOpacity={0.73}
      />
      <g filter="url(#filter2_f_765_5350)">
        <ellipse cx={70.5427} cy={183.496} rx={37.3464} ry={37.2509} fill="#D9D9D9" fillOpacity={0.35} />
      </g>
      <path
        d="M70.4957 203.217C70.4957 183.838 55.166 181.752 55.166 181.752C55.166 181.752 70.4957 182.447 70.4957 159.392C70.4957 182.348 85.8255 181.752 85.8255 181.752C85.8255 181.752 70.4957 183.838 70.4957 203.217Z"
        fill="white"
        fillOpacity={0.73}
      />
      <g filter="url(#filter3_f_765_5350)">
        <ellipse cx={139.704} cy={59.3258} rx={17.9816} ry={17.9356} fill="#D9D9D9" fillOpacity={0.31} />
      </g>
      <path
        d="M139.68 68.8212C139.68 59.4909 132.299 58.4861 132.299 58.4861C132.299 58.4861 139.68 58.8211 139.68 47.7205C139.68 58.7732 147.061 58.4861 147.061 58.4861C147.061 58.4861 139.68 59.4909 139.68 68.8212Z"
        fill="white"
        fillOpacity={0.73}
      />
    </g>
    <defs>
      <filter
        id="filter0_f_765_5350"
        x={19.7258}
        y={47.2384}
        width={231.662}
        height={231.125}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation={5.35392} result="effect1_foregroundBlur_765_5350" />
      </filter>
      <filter
        id="filter1_f_765_5350"
        x={111.466}
        y={6.26014}
        width={117.345}
        height={117.168}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation={12.0463} result="effect1_foregroundBlur_765_5350" />
      </filter>
      <filter
        id="filter2_f_765_5350"
        x={9.10365}
        y={122.152}
        width={122.878}
        height={122.687}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation={12.0463} result="effect1_foregroundBlur_765_5350" />
      </filter>
      <filter
        id="filter3_f_765_5350"
        x={97.63}
        y={17.2975}
        width={84.1482}
        height={84.0566}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation={12.0463} result="effect1_foregroundBlur_765_5350" />
      </filter>
      <linearGradient
        id="paint0_linear_765_5350"
        x1={165.224}
        y1={258.066}
        x2={65.7259}
        y2={85.3922}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F69B05" />
        <stop offset={1} stopColor="#F89237" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_765_5350"
        x1={158.993}
        y1={261.614}
        x2={59.468}
        y2={89.0184}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FA9739" />
        <stop offset={1} stopColor="#D13F05" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_765_5350"
        x1={131.032}
        y1={277.738}
        x2={31.5071}
        y2={105.143}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D87D12" />
        <stop offset={0.5} stopColor="#FF9B3E" />
        <stop offset={1} stopColor="#D87D12" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_765_5350"
        x1={203.428}
        y1={238.985}
        x2={90.5471}
        y2={56.8403}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity={0} />
        <stop offset={0.26} stopColor="white" />
        <stop offset={0.76} stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint4_linear_765_5350"
        x1={78.5047}
        y1={152.662}
        x2={261.51}
        y2={140.254}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD54F" />
        <stop offset={1} stopColor="#FFC000" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_765_5350"
        x1={225.652}
        y1={113.531}
        x2={102.475}
        y2={170.217}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity={0} />
        <stop offset={0.26} stopColor="white" />
        <stop offset={0.76} stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint6_linear_765_5350"
        x1={211.811}
        y1={169.803}
        x2={84.7813}
        y2={125.876}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDB5D" />
        <stop offset={0.603948} stopColor="#FFDD77" />
        <stop offset={1} stopColor="#FFDE89" />
      </linearGradient>
      <radialGradient
        id="paint7_radial_765_5350"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-479.796 473.645) rotate(153.618) scale(5.02677 18.0684)"
      >
        <stop stopColor="white" />
        <stop offset={0.09} stopColor="white" stopOpacity={0.96} />
        <stop offset={0.24} stopColor="white" stopOpacity={0.85} />
        <stop offset={0.43} stopColor="white" stopOpacity={0.66} />
        <stop offset={0.66} stopColor="white" stopOpacity={0.41} />
        <stop offset={0.93} stopColor="white" stopOpacity={0.09} />
        <stop offset={1} stopColor="white" stopOpacity={0} />
      </radialGradient>
      <linearGradient
        id="paint8_linear_765_5350"
        x1={221.765}
        y1={111.318}
        x2={180.387}
        y2={131.916}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint9_linear_765_5350"
        x1={177.654}
        y1={130.73}
        x2={97.2179}
        y2={178.245}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint10_linear_765_5350"
        x1={177.654}
        y1={130.73}
        x2={97.2179}
        y2={178.245}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <clipPath id="clip0_765_5350">
        <rect width={273.874} height={275.933} fill="white" />
      </clipPath>
    </defs>
  </svg>
))`
  width: 68px;
  height: 68px;
`;
